import _ from 'lodash'
import core from '../../core'

// import { valueTable as commonConfigValues } from './commonConfig'

// const { nationalities, gender, userRole, activeStatus } = commonConfigValues

const {
  helpers: {
    // calculateAge,
    isPhone,
    isEmail,
    isFax,
    keepInLength,
    // validateLength,
    // calculatePeriod
    getUserProfileLocal
  }
} = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'ui',
      'sector',
      'organizationName',
      'name',
      'address',
      'phone',
      'fax',
      'email',
      'operationalStatus',
      'registrationStatus',
      'registrationDate',
      'flag'
    ]
  }
]

export const defaultSorting = [{ columnName: 'ui', direction: 'asc' }]

export const operationalStatus = [
  { id: 1, label: 'Closed' },
  { id: 2, label: 'Open' },
  { id: 3, label: 'Open - Closed to Referrals' },
  { id: 4, label: ' Open - Due to Close' }
]

export const registrationStatus = [
  { id: 1, label: 'Full Registration' },
  { id: 2, label: 'Registered with Conditions' },
  { id: 3, label: 'Registration Expired' },
  { id: 4, label: 'Pre-Operational Registation in Place' },
  { id: 5, label: 'Not Registered - Closed' }
]

export const valueTable = {
  operationalStatus,
  registrationStatus
}

export const columns = [
  {
    name: 'id',
    title: 'ID',
    formField: true
  },
  {
    name: 'ui',
    title: 'Centre UI',
    getCellValue: row => row['id'],
    minSpace: 'Centre UI ',
    formField: true
  },
  {
    name: 'status',
    title: 'Centre Status',
    minSpace: 'Centre Status ',
    formField: true,
    hidden: getUserProfileLocal().role !== 'Level 1'
  },
  {
    name: 'sector',
    title: 'Centre Sector',
    minSpace: 'Centre Sector ',
    formField: true,
    hidden: getUserProfileLocal().role === 'Level 1'
  },
  {
    name: 'organisationName',
    title: 'Centre Organisation Name',
    minSpace: 'Centre Organisation ',
    formField: true,
    hidden: getUserProfileLocal().role === 'Level 1'
  },
  {
    name: 'name',
    title: 'Centre / Unit Name',
    // hidden: true,
    minSpace: 'Centre / Unit ',
    formField: true
  },
  {
    name: 'address',
    title: 'Centre Address',
    // hidden: true,
    minSpace: 'Centre Address ',
    formField: true
  },
  {
    name: 'phone',
    title: 'Centre Phone No.',
    // hidden: true,
    minSpace: 'Phone No.   ',
    formField: true
  },
  {
    name: 'fax',
    title: 'Centre Fax No.',
    // hidden: true,
    minSpace: 'Centre ',
    formField: true
  },
  {
    name: 'email',
    title: 'Centre Email Address',
    // hidden: true,
    minSpace: 'Email Address ',
    formField: true
  },
  {
    name: 'operationalStatus',
    title: 'Centre Operational Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(operationalStatus, ['id', parseInt(row[`operationalStatus`], 10)])
        ? _.find(operationalStatus, [
            'id',
            parseInt(row[`operationalStatus`], 10)
          ]).label
        : row[`operationalStatus`],
    options: 'operationalStatus',
    filterField: true,
    hidden: getUserProfileLocal().role === 'Level 1',
    minSpace: 'Centre Operational '
  },
  {
    name: 'validFrom',
    title: 'Centre Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    hidden: getUserProfileLocal().role === 'Level 1',
    minSpace: 'Centre Status '
  },
  {
    name: 'registrationStatus',
    title: 'Centre Registration Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(registrationStatus, [
        'id',
        parseInt(row[`registrationStatus`], 10)
      ])
        ? _.find(registrationStatus, [
            'id',
            parseInt(row[`registrationStatus`], 10)
          ]).label
        : row[`registrationStatus`],
    options: 'registrationStatus',
    filterField: true,
    minSpace: 'Registration Status '
  },
  {
    name: 'registrationDate',
    title: 'Centre Registration Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Registration Date '
  },
  {
    name: 'expiryDate',
    title: 'Centre Registration Expiry',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Registration Expiry '
  },
  {
    name: 'flag',
    title: 'Centre Registration Flag',
    formField: true,
    filterField: true,
    minSpace: 'Centre Registration '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'centre',
      historyName: 'centreHistory',
      label: 'Centre Details',
      icon: 'visibility',
      fields: [
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'id', //'ui',
            disabled: true,
            label: 'Centre UI',
            // hint: 'Enter UI',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 10)
              return val
            }
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'sector',
            label: 'Centre Sector',
            // hint: 'Enter Sector',
            required: showAsterix
            // normalize: v => {
            //   const val = keepInLength(v, 10)
            //   return val
            // }
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'organizationName',
            label: 'Centre Organsiation Name ',
            // hint: 'Enter Name',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            }
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'status',
            label: 'Centre Status',
            // hint: 'Select Status',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: operationalStatus.filter(f => f.id > 0).map(o => {
              return { value: o.label, label: o.label }
            })
          }
        ],

        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'name',
          label: 'Centre / Unit Name',
          // hint: 'Enter Name',
          required: showAsterix,
          normalize: v => {
            const val = keepInLength(v, 50)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'address',
          label: 'Centre Address',
          // hint: 'Enter Address',
          required: showAsterix,
          normalize: v => {
            const val = keepInLength(v, 50)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'phone',
            label: 'Centre Phone No',
            // hint: 'Enter Phone',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              v
                ? isPhone(v)
                  ? undefined
                  : 'Phone number should have 8 or 9 digit with leading 0'
                : 'Field is required'
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'fax',
            label: 'Centre Fax No.',
            // hint: 'Enter Fax',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              v
                ? isFax(v)
                  ? undefined
                  : 'Fax number should have 8 or 9 digit with leading 0'
                : 'Field is required'
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'email',
            label: 'Centre Email Address',
            // hint: 'Enter Email',
            validate: v =>
              v
                ? isEmail(v) ? undefined : 'Enter valid email address'
                : 'Field is required',
            normalize: v => v.toLowerCase()
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'operationalStatus',
            label: 'Centre Operational Status',
            // hint: 'Select Status',
            required: showAsterix,
            hidden: getUserProfileLocal().role === 'Level 1',
            options: operationalStatus.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'validFrom',
            label: 'Centre Status Valid at Date',
            required: showAsterix,
            hidden: getUserProfileLocal().role === 'Level 2',
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],

        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'registrationDate',
            label: 'Centre Registration Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'registrationStatus',
            label: 'Centre Registration Status',
            // hint: 'Select Status',
            required: showAsterix,
            options: registrationStatus.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'registrationExpiry',
            label: 'Centre Registration Expiry ',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          name: 'flag',
          label: 'Centre Registration Flag'
        }

        // {
        //   type: fields.spacer,
        //   style: { height: 40 }
        // }
      ]
    }
    // {
    //   id: 3,
    //   name: 'ypd',
    //   activeName: 'user',
    //   historyName: 'userHistory',
    //   label: 'Personnel Details',
    //   icon: 'person',
    //   hidden: true,
    //   // disabled: true,
    //   fields: []
    // }
  ]

  return forms
}

export const activeSection = ['centre'] //['user']

export const errors = [1]

export const defaultNew = {
  isActive: 1
}

// "personnel": [
//   {
//     "id": 1,
//     personnel:{
//       "ui": "1313",
//       "firstName": "AA",
//       "lastName": "BB",
//       "gender": "Male",
//       "dob": "2001-01-01T23:28:56.782Z",
//       "nationality": "Afghanistan"
//     },
//     "personnelHistory": {

//     },
//     contact:{
//       "historyId": 1,
//       "email": "sss@ss.com",
//       "phone": "1213131414",
//       "address": "12133"
//     },
//     "contactHistory": {

//     }
//   }
// ]



// WEBPACK FOOTER //
// ./src/centre/configs/centre.js